import { msalScopes, authConfig } from './msal'
import type { Msal } from '@base/types/msal'

interface EnvironmentConfig {
  apiUrl: string
  apiVersion?: string
  stripePublishableKey?: string
  msal: Msal
  crmPolicyUrl?: string
  crmBaseUrl?: string
  trakrForSalesUrl?: string
}

type Environments = Record<'development' | 'rc' | 'production', EnvironmentConfig>

const environmentKeyMap: { [key: string]: keyof Environments } = {
  dev: 'development',
  prod: 'production'
}

const environments: Environments = {
  development: {
    apiUrl: 'https://epitrakrorchestrator-np-dev.azurewebsites.net',
    apiVersion: 'v1',
    msal: {
      auth: {
        ...authConfig,
        clientId: 'fd7d6f2c-9cf0-44a1-9af8-348cd746e747',
        scopes: [...msalScopes, 'api://7ac2e6a7-46d9-41de-9d4f-c9f049d85f0f/.default']
      }
    },
    crmPolicyUrl: 'https://crm-dev365.embracepetinsurance.com/Dev365/main.aspx?pagetype=entityrecord&etc=2&id=%7b',
    crmBaseUrl: 'https://crm-dev365.embracepetinsurance.com/Dev365/main.aspx',
    trakrForSalesUrl: 'https://trakr-dev.embracepetinsurance.com/'
  },
  rc: {
    apiUrl: 'https://epitrakrorchestrator-np.azurewebsites.net',
    apiVersion: 'v1',
    msal: {
      auth: {
        ...authConfig,
        clientId: '7e92dd66-de8d-4d83-b680-a23799e65db0',
        scopes: [...msalScopes, 'api://51f89a65-c634-4e62-9134-c4e337101af8/.default']
      }
    },
    crmPolicyUrl: 'https://crm-rc365.embracepetinsurance.com/EmbraceCRM/main.aspx?pagetype=entityrecord&etc=2&id=%7b',
    crmBaseUrl: 'https://crm-rc365.embracepetinsurance.com/EmbraceCRM/main.aspx',
    trakrForSalesUrl: 'https://trakr-rc.embracepetinsurance.com/'
  },
  production: {
    apiUrl: 'https://epitrakrorchestrator-p.azurewebsites.net',
    apiVersion: 'v1',
    msal: {
      auth: {
        ...authConfig,
        clientId: '5ee48d52-9f01-4cab-90bc-40317ca5983c',
        scopes: [...msalScopes, 'api://f102d8c4-4f81-42cf-9e48-d450adc13a7b/.default']
      }
    },
    crmPolicyUrl: 'https://crm-prod.embracepetinsurance.com/EmbraceCRM/main.aspx?pagetype=entityrecord&etc=2&id=%7b',
    crmBaseUrl: 'https://crm-prod.embracepetinsurance.com/EmbraceCRM/main.aspx',
    trakrForSalesUrl: 'https://trakr.embracepetinsurance.com/'
  }
}

const getEnvironment = (key: string): EnvironmentConfig => {
  const envKey = environmentKeyMap[key] || key
  return environments[envKey as keyof Environments]
}

const getAppEnvironment = (): EnvironmentConfig => {
  const {
    public: { APP_ENV = 'development' }
  } = useRuntimeConfig()
  return getEnvironment(APP_ENV)
}

export { environments, getEnvironment, getAppEnvironment }
